import { Component, h } from '@stencil/core';

const reviewContent = [
  {
    id: 0,
    width: '80%',
  },
  {
    id: 1,
    width: '78%',
  },
  {
    id: 2,
    width: '60%',
  },
  {
    id: 3,
    width: '55%',
  },
  {
    id: 4,
    width: '82%',
  },
  {
    id: 5,
    width: '50%',
  },
  {
    id: 6,
    width: '40%',
  },
  {
    id: 7,
    width: '100%',
  },
  {
    id: 8,
    width: '95%',
  },
];
@Component({
  tag: 'ugc-review-list-item-keleton',
  shadow: false,
})
export class UgcReviewListItemSkeleton {
  render() {
    return (
      <div class="my-16 pb-16 border-bottom-solid border-1 border-gray-300">
        <div class="flex-row-start-center gap-16 mb-16">
          <div class="flex-row-start-center gap-2">
            {[0, 1, 2, 3, 4].map(item => (
              <ugc-skeleton width="16" height="16" isCircle key={item} />
            ))}
          </div>
          <ugc-skeleton width="24" height="12.25" />
        </div>
        <div class="mb-16">
          {reviewContent.map(reviewItem => (
            <div class="w-full">
              <ugc-skeleton width={reviewItem.width} height="12.25" />
            </div>
          ))}
        </div>
        <ugc-skeleton width="65" height="12.25" />
      </div>
    );
  }
}
